import React, {useState, useRef} from 'react';
import axios from 'axios';
import cookie from 'js-cookie';
import SendNumber from '../SendNumber';
import { useTranslation } from 'react-i18next';
import { API_URL, API_OK, API_EXCEPTION } from '../../Constants';
import { Box, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PageShell from '../PageShell';


export default function AntiSpam(props) {
  const MESSAGE_LOCATION_SETTING = "setting";
  const MESSAGE_LOCATION_WHITELIST = "whitelist";
  const MESSAGE_LOCATION_WHITELIST_IMPORT = "whitelist_import";

  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const defaultSuccessMessage = t("The operation was successfull");
  const [successMessage, setSuccessMessage] = useState(defaultSuccessMessage);
  const [successMessageLocation, setSuccessMessageLocation] = useState(MESSAGE_LOCATION_SETTING);

  const [showDetailedErrorMessage, setShowDetailedErrorMessage] = useState(false);
  const defaultDetailedErrorMessage = t("The operation was successfull");
  const [detailedErrorMessage, setDetailedErrorMessage] = useState(defaultSuccessMessage);
  const [detailedErrorMessageLocation, setDetailedErrorMessageLocation] = useState(MESSAGE_LOCATION_SETTING);

  const [result, setResult] = useState(null);   // { ok, oks, errors, isMany, message }
  const [failedOpen, setFailedOpen] = useState(false);
  const [mobileTab, setMobileTab] = useState('single');   // 'single' | 'multi' (mobile only)
  const [importing, setImporting] = useState(false);
  const importInputRef = useRef(null);

  // import a CSV/text file of numbers and submit them through the bulk endpoint
  const handleExcelImport = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = '';
    if (!file) return;
    let text = '';
    try { text = await file.text(); } catch { showErrorPopup('לא ניתן לקרוא את הקובץ'); return; }
    const numbers = Array.from(new Set(
      text.split(/[\r\n,;\t]+/).map(s => s.replace(/[^\d+]/g, '')).filter(n => n.replace(/\D/g, '').length >= 4)
    ));
    if (numbers.length === 0) { showErrorPopup('לא נמצאו מספרים בקובץ. ודאו שהקובץ בפורמט CSV עם מספר בכל שורה.'); return; }
    setImporting(true);
    try {
      const { data } = await axios.post(API_URL + '/antiSpam/whiteListImport',
        { numbers, note: 'ייבוא מקובץ', countryCode: 'IL' },
        { headers: { token: cookie.get('token') } });
      if (data && data.responseStatus === API_OK && data.status === true) {
        handleResult({ isMany: true, oks: data.oks != null ? data.oks : numbers.length, errors: data.errors || {} });
      } else {
        showErrorPopup((data && data.responseStatus === API_EXCEPTION && data.message) ? data.message : t('An error occurred'));
      }
    } catch {
      showErrorPopup(t('An error occurred'));
    } finally { setImporting(false); }
  };

  const handleResult = ({ isMany, oks, errors }) => {
    const errCount = errors ? Object.keys(errors).length : 0;
    setFailedOpen(false);
    setResult({ ok: oks > 0 || errCount === 0, oks: oks || 0, errors: errors || {}, isMany, message: null });
  };

  const showErrorPopup = (msg) => {
    setFailedOpen(false);
    setResult({ ok: false, oks: 0, errors: {}, isMany: false, message: msg || t("An error occurred") });
  };

  const closeResultPopup = () => { setResult(null); setFailedOpen(false); };

  const errCount = result ? Object.keys(result.errors).length : 0;

  return <PageShell title="חסימת צינטוקים" subtitle="ניהול מספרים מורשים לחסימת צינטוקים">
      <div className='anti-spam-wrapper'>
        {result && (
          <div className='as-popup-overlay' onClick={closeResultPopup}>
            <div className={'as-popup' + (result.ok ? ' as-popup--ok' : ' as-popup--err')} onClick={(e) => e.stopPropagation()}>
              <div className='as-popup-icon'>
                {result.ok ? (
                  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                ) : (
                  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                )}
              </div>
              <div className='as-popup-title'>
                {result.message
                  ? 'אופס, משהו השתבש'
                  : result.isMany
                    ? (result.oks > 0 ? `נוספו ${result.oks} מספרים בהצלחה` : 'לא נוספו מספרים חדשים')
                    : 'המספר נוסף בהצלחה'}
              </div>
              {result.message && <div className='as-popup-text'>{result.message}</div>}

              {errCount > 0 && (
                <div className='as-failed'>
                  <button className={'as-failed-toggle' + (failedOpen ? ' open' : '')} onClick={() => setFailedOpen(o => !o)}>
                    <span className='as-failed-count'>{errCount}</span>
                    <span>מספרים שנכשלו</span>
                    <svg className='as-failed-chev' width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
                  </button>
                  {failedOpen && (
                    <div className='as-failed-list'>
                      {Object.entries(result.errors).map(([num, reason]) => (
                        <div className='as-failed-row' key={num}>
                          <span className='as-failed-num'>{num}</span>
                          <span className='as-failed-reason'>{reason}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}

              <button className='as-popup-btn' onClick={closeResultPopup}>{t('Close')}</button>
            </div>
          </div>
        )}
      <div className={'as-cards as-cards--' + mobileTab}>

      {/* info box — third box (next to the add boxes; above them on mobile) */}
      <div className='as-acc as-acc--static'>
        <div className='as-acc-head'>
          <span className='as-acc-icon'>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
          </span>
          <span className='as-acc-head-text'>
            <span className='as-acc-title'>איך חסימת הצינטוקים עובדת?</span>
            <span className='as-acc-sub'>מידע על השירות ולמה כדאי</span>
          </span>
        </div>
        <div className='as-acc-body'>
          <p>המערכת חוסמת אוטומטית מספרים שמזוהים כ<strong>צינטוקים</strong> או כ<strong>ספאם</strong> עבור המנויים הרשומים בקהילה. בעמוד זה ניתן להגדיר <strong>מספרים מורשים</strong> שיוכלו לחייג למנויים ללא הגבלה — גם אם הם מזוהים כצינטוקים.</p>
          <div className='as-why-points'>
            <div className='as-why-point'>
              <span className='as-why-point-icon'>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><path d="M9 12l2 2 4-4"/></svg>
              </span>
              <div>
                <div className='as-why-point-title'>סינון צינטוקים ושיחות רובוטיות</div>
                <div className='as-why-point-sub'>סינון שיחות תעמולה ומבזקים אוטומטיים — אפס הטרדות, גם בלילה או בשעת הלימוד.</div>
              </div>
            </div>
            <div className='as-why-point'>
              <span className='as-why-point-icon'>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
              </span>
              <div>
                <div className='as-why-point-title'>רשימת מספרים מורשים</div>
                <div className='as-why-point-sub'>אתם מגדירים מי כן יוכל לחייג למנויים — למשל ההורים בלבד — בעוד כל השאר מסונן.</div>
              </div>
            </div>
          </div>
          <a className='as-leaflet' href={`${process.env.PUBLIC_URL}/למה כדאי לחסום צינתוקים.pdf`} download target='_blank' rel='noopener noreferrer'>
            <span className='as-leaflet-icon'>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
            </span>
            <span className='as-leaflet-text'>הורדת עלון מידע על צינתוקים</span>
          </a>
        </div>
      </div>

      {/* mobile tabs — separate single vs. bulk whitelist */}
      <div className='as-mtabs'>
        <button className={'as-mtab' + (mobileTab === 'single' ? ' active' : '')} onClick={() => setMobileTab('single')}>החרגת מספר בודד</button>
        <button className={'as-mtab' + (mobileTab === 'multi' ? ' active' : '')} onClick={() => setMobileTab('multi')}>החרגת מספרים רבים</button>
      </div>

        <div className='as-single'>
          <SendNumber
            type="whitelist"
            apiUrl={API_URL + '/antiSpam/whiteList'}
            setLoading={setLoading}
            messageLocation={MESSAGE_LOCATION_WHITELIST}
            setSuccessMessageLocation={setSuccessMessageLocation}
            setShowSuccessMessage={setShowSuccessMessage}
            onResult={handleResult}
            onError={showErrorPopup}
            commentHint="הכניסו כאן את הסיבה לשחרור המספר מהחסימה"
            title={t("Whitelist a number")}
            buttonTitle={t('Submit whitelist')}
            footer={(
              <div className='as-import'>
                <div className='as-import-text'>
                  <span className='as-import-title'>ייבוא מאקסל</span>
                  <span className='as-import-sub'>קובץ CSV עם מספר בכל שורה — כל המספרים יישלחו יחד</span>
                </div>
                <button type='button' className='as-import-btn' onClick={() => importInputRef.current && importInputRef.current.click()} disabled={importing}>
                  {importing ? (
                    <span className='as-import-spinner' />
                  ) : (
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
                  )}
                  {importing ? 'מייבא...' : 'בחירת קובץ'}
                </button>
                <input ref={importInputRef} type='file' accept='.csv,.txt' hidden onChange={handleExcelImport} />
              </div>
            )}
            />
        </div>
        <div className='as-multi'>
          <SendNumber
            type="whitelist"
            isMany={true}
            apiUrl={API_URL + '/antiSpam/whiteListImport'}
            messageLocation={MESSAGE_LOCATION_WHITELIST_IMPORT}
            setSuccessMessageLocation={setSuccessMessageLocation}
            setShowSuccessMessage={setShowSuccessMessage}
            setDetailedErrorMessageLocation={setDetailedErrorMessageLocation}
            setShowDetailedErrorMessage={setShowDetailedErrorMessage}
            setDetailedErrorMessage={setDetailedErrorMessage}
            onResult={handleResult}
            onError={showErrorPopup}
            title={t("Whitelist numbers")}
            note={t("Please paste a list of numbers")}
            buttonTitle={t('Submit whitelist')}
            setLoading={setLoading}
            />
        </div>
      </div>
      </div>
  </PageShell>
}
